import { jsxs as e, jsx as l } from "react/jsx-runtime";
const d = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M88 50C88 70.987 70.987 88 50 88C29.013 88 12 70.987 12 50C12 29.013 29.013 12 50 12C70.987 12 88 29.013 88 50Z",
          fill: "#F3F3FD"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M70.8558 88C74.8087 88 77.1984 83.6295 75.0652 80.3017L56.3331 51.0797C55.516 49.805 55.4887 48.1781 56.2625 46.8767L73.4061 18.0443C74.9915 15.378 73.07 12 69.9679 12H30.0321C26.93 12 25.0085 15.378 26.5939 18.0443L43.7375 46.8767C44.5113 48.1782 44.484 49.805 43.6669 51.0797L24.9348 80.3017C22.8016 83.6295 25.1913 88 29.1442 88H70.8558Z",
          fill: "white",
          stroke: "var(--plac-primary-gray)",
          strokeWidth: "2",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M20 12H80",
          stroke: "var(--plac-primary-gray)",
          strokeWidth: "2",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M17 88H83",
          stroke: "var(--plac-primary-gray)",
          strokeWidth: "2",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M52 48C52 49.104 51.104 50 50 50C48.896 50 48 49.104 48 48C48 46.896 48.896 46 50 46C51.104 46 52 46.896 52 48Z",
          fill: "var(--plac-icon-fill-active)"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M48 40C48 41.104 47.104 42 46 42C44.896 42 44 41.104 44 40C44 38.896 44.896 38 46 38C47.104 38 48 38.896 48 40Z",
          fill: "var(--plac-icon-fill-active)"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M56 38C56 39.104 55.104 40 54 40C52.896 40 52 39.104 52 38C52 36.896 52.896 36 54 36C55.104 36 56 36.896 56 38Z",
          fill: "var(--plac-icon-fill-active)"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M52 61C52 62.104 51.104 63 50 63C48.896 63 48 62.104 48 61C48 59.896 48.896 59 50 59C51.104 59 52 59.896 52 61Z",
          fill: "var(--plac-icon-fill-active)"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M69.0268 84.0003C70.608 84.0003 71.5639 82.2522 70.7106 80.921L60.8964 65.6103C59.8734 64.0153 57.6474 63.7563 56.2854 65.0733L49.5614 71.5753C48.1014 72.9863 45.8144 73.0803 44.2444 71.7923L40.8854 69.0383C39.4964 67.8993 37.4264 68.2273 36.4564 69.7393L29.2892 80.921C28.4359 82.2522 29.3918 84.0003 30.973 84.0003H69.0268Z",
          fill: "var(--plac-icon-fill-active)"
        }
      )
    ]
  }
);
export {
  d as ExpireIllustrationNoBackground
};
//# sourceMappingURL=index.es494.js.map
